import { useScreenWidth } from "@/lib/hooks";
import { AsideMenuItemLinkType, BgColorType, SpacingType } from "@/lib/main";
import AsideNav from "./AsideNav";
import AsideNavSelect from "./AsideNavSelect";

type PropsType = {
  asideMenuItems: AsideMenuItemLinkType[];
  placeholder?: string;
  bgColor?: BgColorType;
  columnGap?: SpacingType;
  rowGap?: SpacingType;
  breakpoint?: number;
};

export default function AsideNavOrSelect({
  asideMenuItems,
  placeholder,
  bgColor,
  columnGap,
  rowGap,
  breakpoint,
}: PropsType) {
  const { screenWidth, tabletBreakpoint } = useScreenWidth();
  const threshold = breakpoint ?? tabletBreakpoint;

  if (screenWidth < threshold) {
    return (
      <AsideNavSelect
        asideMenuItems={asideMenuItems}
        placeholder={placeholder}
        bgColor={bgColor}
      />
    );
  }

  return (
    <AsideNav
      asideMenuItems={asideMenuItems}
      bgColor={bgColor}
      columnGap={columnGap}
      rowGap={rowGap}
    />
  );
}
